module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1297.120a916a.jpg";